"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Context_1 = require("../../Context");
const ContentScroll_1 = __importDefault(require("../ContentScroll"));
const style_module_scss_1 = __importDefault(require("../../style.module.scss"));
const hooks_1 = require("../../hooks");
;
const Modal = (_a) => {
    var { onBackground, onClose, renderProps } = _a, props = __rest(_a, ["onBackground", "onClose", "renderProps"]);
    const { render, dialogStyle, hideCloseButton, className, style, title, children, contentStyle, closeLabel, bottomSheetMaxWidth, draggable } = props;
    const Styles = (0, hooks_1.useStyle)(style_module_scss_1.default, '_modal-');
    const containerContext = (0, react_1.useContext)(Context_1.ContainerContext);
    const modalRef = (0, react_1.useRef)(null);
    const [position, setPosition] = (0, react_1.useState)({
        x: 0,
        y: 0
    });
    const startPosition = (0, react_1.useRef)({
        x: 0,
        y: 0
    });
    const endPosition = (0, react_1.useRef)({
        x: 0,
        y: 0
    });
    const modalSize = (0, react_1.useRef)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const panActive = (0, react_1.useRef)(false);
    const handleMoveStart = (_a) => {
        var _b;
        var { target } = _a, e = __rest(_a, ["target"]);
        if (!target.closest('header') || !draggable || !modalRef.current)
            return;
        const { x, y, width, height } = modalRef.current.getBoundingClientRect();
        const { clientX, clientY } = 'touches' in e ? e.touches[0] : e;
        panActive.current = true;
        startPosition.current = {
            x: clientX,
            y: clientY
        };
        modalSize.current = {
            x,
            y,
            width,
            height
        };
        (_b = modalRef.current) === null || _b === void 0 ? void 0 : _b.classList.add(style_module_scss_1.default['drag']);
    };
    const handleMoveEnd = () => {
        var _a;
        if (!panActive.current)
            return;
        panActive.current = false;
        endPosition.current = Object.assign({}, position);
        (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove(style_module_scss_1.default['drag']);
    };
    const handleMove = (e) => {
        if (!panActive.current)
            return;
        const { clientX, clientY } = 'touches' in e ? e.touches[0] : e;
        const dx = clientX - startPosition.current.x;
        const dy = clientY - startPosition.current.y;
        const newX = endPosition.current.x + dx;
        const newY = endPosition.current.y + dy;
        const halfW = window.innerWidth / 2;
        const halfH = window.innerHeight / 2;
        const maxX = halfW - modalSize.current.width / 2;
        const maxY = halfH - modalSize.current.height / 2;
        const clampedX = Math.max(Math.min(newX, maxX), -maxX);
        const clampedY = Math.max(Math.min(newY, maxY), -maxY);
        setPosition({ x: clampedX, y: clampedY });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: Styles('modal-wrapper'), onMouseDown: handleMoveStart, onMouseUp: handleMoveEnd, onMouseLeave: handleMoveEnd, onMouseMove: handleMove, onTouchStart: handleMoveStart, onTouchEnd: handleMoveEnd, onTouchCancel: handleMoveEnd, onTouchMove: handleMove, children: [(0, jsx_runtime_1.jsx)("div", { className: Styles('background'), onClick: onBackground }), (0, jsx_runtime_1.jsxs)("dialog", { className: Styles('modal-container'), tabIndex: 1, role: "dialog", style: Object.assign(Object.assign({}, dialogStyle), { maxWidth: bottomSheetMaxWidth, transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))` }), ref: modalRef, open: true, children: [(typeof render === 'function' && !hideCloseButton) &&
                        (0, jsx_runtime_1.jsx)("div", { className: Styles('close-block'), onClick: onBackground, children: (0, jsx_runtime_1.jsx)("div", { className: Styles(['close', 'large']), onClick: onClose }) }), typeof render === 'function' ? render(renderProps) :
                        (0, jsx_runtime_1.jsxs)("div", { className: Styles('modal') + (className ? ' ' + className : ''), style: style, children: [(0, jsx_runtime_1.jsxs)("header", { className: Styles('header'), children: [(0, jsx_runtime_1.jsx)("div", { className: Styles('text'), children: title }), (!hideCloseButton) && (closeLabel ? (0, jsx_runtime_1.jsx)("span", { children: closeLabel, onClick: onClose }) : (0, jsx_runtime_1.jsx)("span", { className: Styles('close'), onClick: onClose }))] }), (0, jsx_runtime_1.jsx)(ContentScroll_1.default, { className: Styles('content'), style: contentStyle, active: true, children: children }), containerContext.footer ? (0, jsx_runtime_1.jsx)("footer", { className: Styles('footer'), ref: renderProps.footerRef, children: containerContext.footer }) : null] })] })] }));
};
exports.Modal = Modal;
